/* svnty-quickadd-door.js: THE QUICK-ADD DOOR (D4-6, 2026-09-25; v2 D6-16, R206). THE STATUS BAR law says
 * every door hangs from the header inside the slab as an absolute box, or iOS paints the bar's strip through it. Since D6-16
 * the page has ONE door (#SvntyDoor, snippets/svnty-door-shell.liquid) and assets/quick-add.js hangs it in the slab the moment
 * it upgrades; nothing here moves it any more (the old hook carried it into the header on every open and home on every
 * close). The body lock (overflow-hidden) claims the slab, so the bar parks, the root paints white and the curtain rises.
 * This file owns the door's own parts: THE RAIL (every picture of the shown colour, one per view, snapped, lazy), its colour,
 * and its hanger's paired sheet. */
(function () {
  'use strict';
  var slice = function (l) { return Array.prototype.slice.call(l); };
  function idle(fn, t) { if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: t || 800 }); else setTimeout(fn, 60); }

  /* ======================================================================================================================
   * THE RAIL (D6-16): the door's pictures, one per view at the column's width, `scroll-snap-type: x mandatory` (a swipe on the
   * phone, the trackpad or the wheel at desktop), THE PICTURE AS IS (whole, its own ratio, capped by the CSS). The product
   * page's own grammar over it: THE PILL ("1 | 7", the shown colour's count) and the hanger on the picture's corner (its
   * horizontal place is CSS from the shown picture's ratio, --qd-r; no geometry is read to place it). The first picture is
   * written eager (decoded by the prefetch); every other one carries only a base URL (data-u) and takes its srcset when the
   * rail comes within one picture of it (an IntersectionObserver rooted on the rail); a hidden colour's slides are display:
   * none and cost nothing until a pick shows them.
   * ==================================================================================================================== */
  var W = [600, 800, 900, 1200];
  var SIZES = '(min-width: 750px) calc(min(1040px, 100vw - 48px) * 0.535 - 48px), 100vw';
  function fill(img, base) {
    var u = img.getAttribute('data-u'); if (!u) return;
    var at = base + u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=';
    img.removeAttribute('data-u');
    img.decoding = 'async';
    img.sizes = SIZES;
    img.srcset = W.map(function (w) { return at + w + ' ' + w + 'w'; }).join(', ');
    img.src = at + '900';
    /* decoded off the main thread before the rail brings it in (the swipe never waits on a decode) */
    if (img.decode) img.decode().catch(function () {});
  }
  function shownSlides(rail) { return slice(rail.children).filter(function (li) { return !li.classList.contains('svnty-colour-hidden'); }); }
  function railOf(root) { return root && root.querySelector('[data-svnty-qd-rail]'); }
  function pill(root, idx) {
    var rail = railOf(root); if (!rail) return;
    var list = shownSlides(rail), n = list.length, gal = rail.parentElement;
    var i = Math.max(0, Math.min(n - 1, idx || 0));
    var cur = gal.querySelector('[data-svnty-gal-current]'), tot = gal.querySelector('[data-svnty-gal-total]'), box = gal.querySelector('.svnty-qd__count');
    if (cur && cur.textContent !== String(i + 1)) cur.textContent = String(i + 1);
    if (tot && tot.textContent !== String(n)) tot.textContent = String(n);
    if (box) box.hidden = n < 2;
    var li = list[i], r = li && li.style.getPropertyValue('--r');
    if (r && gal.__svntyR !== r) { gal.__svntyR = r; gal.style.setProperty('--qd-r', r); }
    rail.__svntyIdx = i;
  }
  function mountRail(root) {
    var rail = railOf(root); if (!rail || rail.__svntyRail) return;
    rail.__svntyRail = true;
    var base = rail.getAttribute('data-base') || '';
    var lazy = slice(rail.querySelectorAll('img[data-u]'));
    if (typeof IntersectionObserver === 'function') {
      var io = new IntersectionObserver(function (list) {
        list.forEach(function (x) { if (x.isIntersecting) { fill(x.target, base); io.unobserve(x.target); } });
      }, { root: rail, rootMargin: '0px 100% 0px 100%' });
      lazy.forEach(function (img) { io.observe(img); });
      rail.__svntyIo = io;
    } else lazy.forEach(function (img) { fill(img, base); });
    pill(root, 0);
    /* THE PILL follows the rail: the index from scrollLeft / the rail's width, read on a frame, never during the open */
    var raf = 0;
    rail.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; var w = rail.clientWidth || 1; pill(root, Math.round(rail.scrollLeft / w)); });
    }, { passive: true });
    /* the wheel at desktop: a vertical wheel over the rail turns one picture (the door's left column never scrolls) */
    var wheelAt = 0;
    rail.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;   /* a trackpad's sideways swipe is the rail's own */
      e.preventDefault();
      var now = Date.now(); if (now - wheelAt < 380 || Math.abs(e.deltaY) < 4) return; wheelAt = now;
      var n = shownSlides(rail).length, i = (rail.__svntyIdx || 0) + (e.deltaY > 0 ? 1 : -1);
      if (i < 0 || i >= n) return;
      rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' });
    }, { passive: false });
  }

  /* ======================================================================================================================
   * THE DOOR'S OWN COLOUR (D5-3, C-02, A RULED): the door is its own bus instance. A colour picked inside the door moves
   * the door's picture (the colour's pictures shown, the variant's own first, in the frame of that pick), and "See the full
   * page" opens that colour and size; the Color label, the sizes and the button words come from svnty-pdp.js mounted on the
   * door root (SVNTY.pdpMount). Nothing here reads or writes window.SVNTY.colour: the page's bus never hears a door pick.
   * ==================================================================================================================== */
  function doorRootOf(el) { var m = el && el.closest && el.closest('quick-add-modal'); return m ? m.querySelector('[id^="QuickAddInfo-"]') : null; }
  function isColourName(n) { n = String(n || '').toLowerCase(); return n.indexOf('colour') >= 0 || n.indexOf('color') >= 0; }
  function doorColour(vs) {
    var wraps = vs.querySelectorAll('.product-form__input');
    for (var i = 0; i < wraps.length; i++) {
      if (!isColourName(wraps[i].getAttribute('data-svnty-option') || (wraps[i].querySelector('legend') || {}).textContent)) continue;
      /* THE STRIPE NAME (D8-8, R239): name = the colour as the door prints it ("Blue stripe"), data-svnty-name on the input */
      var r = wraps[i].querySelector('input[type="radio"]:checked'); if (r) return { pos: i, value: r.value, name: r.getAttribute('data-svnty-name') || r.value };
      var sel = wraps[i].querySelector('select'); if (sel) { var so = sel.options[sel.selectedIndex]; return { pos: i, value: sel.value, name: (so && so.getAttribute('data-svnty-name')) || sel.value }; }
    }
    return null;
  }
  function variantsOf(vs) { try { return typeof vs.getVariantData === 'function' ? vs.getVariantData() : JSON.parse(vs.querySelector('[type="application/json"]').textContent); } catch (e) { return []; } }
  /* a picture's colour is data (product-thumbnail.liquid prints data-svnty-colour), never read from its alt */
  function tagOf(li) { var t = li.querySelector('[data-svnty-colour]'); return (t && t.getAttribute('data-svnty-colour')) || ''; }
  function follow(root) {
    var vs = root && root.querySelector('variant-selects'); if (!vs) return;
    var c = doorColour(vs), list = variantsOf(vs), cur = vs.currentVariant || null;
    if (c) {
      /* the variant that decides the picture: the one picked, else the colour's first (a size missing in this colour) */
      var lead = cur && cur.options && cur.options[c.pos] === c.value ? cur : null;
      if (!lead) for (var i = 0; i < list.length; i++) if (list[i].options && list[i].options[c.pos] === c.value) { lead = list[i]; break; }
      var was = root.getAttribute('data-svnty-door-colour');
      var items = Array.prototype.slice.call(root.querySelectorAll('.product__media-item')), any = false;
      items.forEach(function (li) { var t = tagOf(li); var hide = !!t && t !== c.value; if (li.classList.contains('svnty-colour-hidden') !== hide) li.classList.toggle('svnty-colour-hidden', hide); if (!hide) any = true; });
      if (!any) items.forEach(function (li) { li.classList.remove('svnty-colour-hidden'); });
      var fm = lead && lead.featured_media, first = fm && root.querySelector('.product__media-item[data-media-id$="-' + fm.id + '"]');
      if (first && !first.classList.contains('svnty-colour-hidden') && first.parentElement.firstElementChild !== first) first.parentElement.insertBefore(first, first.parentElement.firstElementChild);
      root.setAttribute('data-svnty-door-colour', c.value);
      root.setAttribute('data-svnty-door-colour-name', c.name);
      /* D6-16 THE RAIL: a new colour starts at its first picture (the variant's own), the pill recounts; the door's heart keeps
         the picture of the colour it would save (the compact variant list carries no picture) */
      var rail = railOf(root);
      if (rail && was && was !== c.value) {
        rail.scrollLeft = 0; pill(root, 0);
        var lim = shownSlides(rail)[0], im = lim && lim.querySelector('img');
        if (im && im.getAttribute('data-u')) fill(im, rail.getAttribute('data-base') || '');
        var src = im && (im.getAttribute('src') || '').split('&width=')[0];
        slice(root.querySelectorAll('svnty-wishlist-toggle.svnty-heart--pdp')).forEach(function (h) {
          if (!src) return;
          h.setAttribute('data-image', src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=400');
          h.setAttribute('data-image-2x', src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=800');
        });
      } else if (rail) pill(root, rail.__svntyIdx || 0);
      var cap = root.querySelector('[data-svnty-door-paired-colour]'); if (cap) cap.textContent = c.name;
    }
    var id = (cur && cur.id) || (root.querySelector('form input[name="id"]') || {}).value;
    var full = root.querySelector('.product__view-details');
    if (full && id) full.setAttribute('href', (full.getAttribute('href') || '').split('?')[0] + '?variant=' + id);
  }
  /* the pick: after variant-selects resolved it (its own listener runs first, on the element), and again after Trade's
     fetch re-sorted the pictures */
  document.addEventListener('change', function (e) {
    var root = doorRootOf(e.target); if (!root || !root.contains(e.target) || !e.target.closest('variant-selects')) return;
    var before = root.getAttribute('data-svnty-door-colour') || '';
    follow(root);
    var now = root.getAttribute('data-svnty-door-colour') || '';
    /* C-26: the taste recorder hears a colour only when the shopper picks one in the door (svnty-taste.js onQuick) */
    if (now && now !== before) document.dispatchEvent(new CustomEvent('svnty:quickview', { detail: { type: 'quickview', handle: decodeURIComponent(handleOfRoot(root)), colour: now, picked: true } }));
  });
  /* the door was written (assets/quick-add.js): its rail wakes (before the open, so nothing below reads a geometry) */
  document.addEventListener('svnty:pdp:rendered', function (e) { var r = e.detail && e.detail.door; if (r) mountRail(r); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) {
    try { subscribe(PUB_SUB_EVENTS.variantChange, function () { document.querySelectorAll('quick-add-modal[open]').forEach(function (m) { follow(m.querySelector('[id^="QuickAddInfo-"]')); }); }); } catch (e) {}
  }

  /* ======================================================================================================================
   * THE DOOR'S HANGER (D5-3, C-06, A RULED): the hanger inside a door opens the DOOR product's PAIRED ITEMS, on every page:
   * the product's own sheet is fetched once (sections/svnty-paired-fetch.liquid, the same snippet the product page renders),
   * hung in the header beside the door (THE STATUS BAR law), its rows switched to the door's colour or to the picture on
   * screen; the scrim, the X and Escape close it and leave the door open, focus goes back to the hanger. A product with no
   * pairs shows no hanger in its door.
   * ==================================================================================================================== */
  var pairedCache = {};
  function base() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function handleOfRoot(root) {
    var vs = root && root.querySelector('variant-selects'), u = (vs && vs.getAttribute('data-url')) || '';
    if (!u) { var a = root && root.querySelector('.product__view-details'); u = (a && a.getAttribute('href')) || ''; }
    return (u.match(/\/products\/([^/?#]+)/) || [])[1] || '';
  }
  function pairedFor(handle) {
    if (!handle) return Promise.resolve(null);
    if (!pairedCache[handle]) {
      pairedCache[handle] = fetch(base() + 'products/' + handle + '?section_id=svnty-paired-fetch', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('paired'); return r.text(); })
        .then(function (t) {
          var doc = new DOMParser().parseFromString(t, 'text/html');
          var el = doc.querySelector('[data-svnty-paired]'); if (!el) return null;
          Array.prototype.forEach.call(doc.querySelectorAll('link[rel="stylesheet"]'), function (l) {
            var h = l.getAttribute('href'); if (!h) return;
            var have = Array.prototype.some.call(document.querySelectorAll('link[rel="stylesheet"]'), function (x) { return x.getAttribute('href') === h; });
            if (!have) { var n = document.createElement('link'); n.rel = 'stylesheet'; n.href = h; document.head.appendChild(n); }
          });
          /* D6-16: no <link> or <style> rides into the page with the sheet (a sheet added to the page restyles every element) */
          Array.prototype.forEach.call(el.querySelectorAll('script, link[rel="stylesheet"], style'), function (x) { x.remove(); });
          /* the rows: into the sheet's slot (the product page fills the same slot from svnty-paired-body) */
          var lists = doc.querySelector('[data-paired-lists]'), slot = el.querySelector('[data-paired-slot]');
          if (lists) { lists.hidden = false; if (slot) { slot.textContent = ''; slot.appendChild(lists); } else { var pl = el.querySelector('[data-paired-list]'); if (pl) pl.appendChild(lists); } }
          var ld = el.querySelector('[data-paired-loading]'); if (ld) ld.hidden = true;
          if (!el.querySelector('.svnty-paired__row')) return null;
          el.removeAttribute('data-svnty-paired');
          el.setAttribute('data-svnty-paired-door', handle);
          var title = el.querySelector('#svnty-paired-title'); if (title) title.id = 'svnty-paired-title-door';
          var panel = el.querySelector('.svnty-paired__panel'); if (panel) panel.setAttribute('aria-labelledby', 'svnty-paired-title-door');
          var cap = el.querySelector('[data-paired-caption-color]'); if (cap) { cap.removeAttribute('data-paired-caption-color'); cap.setAttribute('data-svnty-door-paired-colour', ''); }
          return document.importNode(el, true);
        })
        .catch(function () { delete pairedCache[handle]; return null; });
    }
    return pairedCache[handle];
  }
  function showGroup(sheet, colour, mid) {
    var list = sheet.querySelector('[data-paired-list]'); if (!list) return;
    var label = list.querySelector('[data-paired-label]'), picHit = null;
    var pics = list.querySelectorAll('[data-picture]'), groups = list.querySelectorAll('[data-paired-colour]');
    Array.prototype.forEach.call(pics, function (g) { if (g.getAttribute('data-picture') === mid) picHit = g; });
    Array.prototype.forEach.call(pics, function (g) { g.hidden = g !== picHit; });
    if (picHit) {
      Array.prototype.forEach.call(groups, function (g) { g.hidden = true; });
      if (label) { label.textContent = label.getAttribute('data-label-picture') || ''; label.hidden = false; }
    } else if (groups.length) {
      var hit = null;
      Array.prototype.forEach.call(groups, function (g) { if (g.getAttribute('data-paired-colour') === colour) hit = g; });
      hit = hit || groups[0];
      Array.prototype.forEach.call(groups, function (g) { g.hidden = g !== hit; });
      if (label) { label.textContent = (label.getAttribute('data-label-palette') || '') + ' ' + (hit.getAttribute('data-paired-colour-name') || hit.getAttribute('data-paired-colour') || colour); label.hidden = false; }
    }
  }
  /* the sheet waits beside the door, hidden (display: none, so it costs no style or layout until it opens) */
  function park(sheet, m) {
    var host = m.parentElement || document.body;
    if (sheet.parentElement !== host || sheet.previousElementSibling !== m) host.insertBefore(sheet, m.nextSibling);
    if (!sheet.__svntyWired) {
      sheet.__svntyWired = true;
      Array.prototype.forEach.call(sheet.querySelectorAll('[data-paired-close]'), function (x) { x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closePaired(); }); });
    }
  }
  document.addEventListener('pointerdown', function (e) {
    var h = e.target.closest && e.target.closest('quick-add-modal [data-svnty-hanger]'); if (!h) return;
    var root = doorRootOf(h); if (root) pairedFor(handleOfRoot(root));
  }, { passive: true, capture: true });
  var openSheet = null;
  function closePaired() {
    var o = openSheet; if (!o) return;
    openSheet = null;
    o.sheet.classList.remove('is-open');
    document.removeEventListener('keydown', o.onKey, true);
    setTimeout(function () { if (openSheet !== o) o.sheet.hidden = true; }, 260);
    if (o.from && o.from.isConnected) try { o.from.focus({ preventScroll: true }); } catch (e) {}
  }
  function openPaired(hanger) {
    var root = doorRootOf(hanger), m = hanger.closest('quick-add-modal');
    if (!root || !m) return;
    pairedFor(handleOfRoot(root)).then(function (sheet) {
      if (!sheet) { Array.prototype.forEach.call(root.querySelectorAll('[data-svnty-hanger]'), function (h) { h.hidden = true; }); return; }
      if (!m.hasAttribute('open')) return;
      park(sheet, m);
      /* D6-16: the sheet's top picture is the one the rail shows now */
      var rl = railOf(root), sl = rl ? shownSlides(rl) : [];
      var shown = sl[(rl && rl.__svntyIdx) || 0] || root.querySelector('.product__media-item:not(.svnty-colour-hidden)'), img = shown && shown.querySelector('img');
      var mid = ((shown && shown.getAttribute('data-media-id')) || '').split('-').pop();
      var hero = sheet.querySelector('[data-paired-hero]'); if (hero) { hero.textContent = ''; if (img) { var n = document.createElement('img'); n.src = img.currentSrc || img.src; n.alt = ''; hero.appendChild(n); } }
      var colour = root.getAttribute('data-svnty-door-colour') || '';
      var cap = sheet.querySelector('[data-svnty-door-paired-colour]'); if (cap) cap.textContent = root.getAttribute('data-svnty-door-colour-name') || colour;
      showGroup(sheet, colour, mid);
      sheet.hidden = false;
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
      var o = { sheet: sheet, from: hanger, onKey: function (e) { if (e.key === 'Escape') { e.stopPropagation(); e.preventDefault(); closePaired(); } } };
      openSheet = o;
      document.addEventListener('keydown', o.onKey, true);
      var panel = sheet.querySelector('.svnty-paired__panel');
      setTimeout(function () { if (panel) try { panel.focus({ preventScroll: true }); } catch (e) {} }, 60);
    });
  }
  /* the door's hanger never reaches the page's own paired sheet (svnty-paired.js listens in the bubble phase) */
  document.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('quick-add-modal [data-svnty-hanger]'); if (!h) return;
    e.preventDefault(); e.stopPropagation();
    openPaired(h);
  }, true);
  /* the door closes: its paired sheet closes with it */
  if (typeof MutationObserver === 'function') new MutationObserver(function (ms) {
    ms.forEach(function (x) {
      if (x.target.tagName !== 'QUICK-ADD-MODAL') return;
      if (!x.target.hasAttribute('open')) { if (openSheet) { var o = openSheet; o.from = null; closePaired(); } return; }
      var root = x.target.querySelector('[id^="QuickAddInfo-"]');
      follow(root);
      /* a product without pairs shows no hanger; the sheet (its rows included) is fetched once per product at the door's first
         idle moment, parsed and hung beside the door hidden, so a tap on the hanger opens it with no fetch and no parse
         (D6-16); a finger or a mouse on the hanger starts it at once */
      var hg = root ? root.querySelectorAll('[data-svnty-hanger]') : [];
      if (hg.length) idle(function () {
        if (!x.target.hasAttribute('open')) return;
        pairedFor(handleOfRoot(root)).then(function (sheet) {
          if (!sheet) { Array.prototype.forEach.call(hg, function (h) { h.hidden = true; }); return; }
          park(sheet, x.target);
        });
      }, 1200);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();
